module.exports = __webpack_public_path__ + "img/DSC_9748-2.a94b9dc4.jpeg";